// Make this flag available to the client-side (JavaScript) SDK

import { TogglesReduxState } from './feature-togglings'

// If you want these common features to appear client side ensure that in launch darkly the following checkbox is enabled
export type Features =
    | 'brightcove-player'
    | 'ix-header-tag-wrapper'
    | 'email-author'
    | 'google-tag-manager'
    | 'gpt-ads'
    | 'nielsen-events'
    | 'refresh-on-inactive'
    | 'can-autoplay-video'
    | 'can-autoplay-muted-video'
    | 'can-autoplay-next'
    | 'big-mobile-amp'
    | 'related-content'
    | 'snowplow'
    | 'prebid-video'
    | 'debug-ads'
    | 'newsletter-subscription-banner'
    | 'sticky-mrec'
    | 'standalone-amp-swm-player'
    | 'moat-adx-ad-tracking'
    | 'nielsen-video-events'
    | 'inline-card-video'
    | 'search'
    | 'canary'
    | 'world-collection'
    // | 'use-oovvuu-recommendation'
    | 'cricketball'
    | 'digital-subscriptions'
    | 'bonzai-truskin'
    | 'outstream'
    | 'ad-tech-dfp-testing'
    | 'nielsen-video-events-inline-videos'
    | 'grapeshot'
    | 'mmo-bypass'
    | 'paywall-bypass-header'
    | 'ripple'
    | 'regionals'
    | 'immersive-story-article-template'
    | 'telethon-countdown'
    | 'running-parallax'
    | 'logo-takeover'
    | 'afl-draft'
    | 'simple-digital-subscription-form'
    | 'moat-yield-intelligence'
    | 'exclude-regional-topics-from-lists'
    | 'video-playlist'
    | 'cookie-consent'
    | 'community-news'
    | 'puzzles-target'
    | 'the-west-live'
    | 'playlists-on-inline-videos'
    | 'native-lazy-loading'
    | 'force-west-live-activation'
    | 'video-series'
    | 'sport-breach-screen-variant'
    | 'taboola'
    | 'taboola-regionals'
    | 'companion-ads'
    | 'story-classification'
    | 'the-west-rewards'
    | 'registration-wall'
    | 'comments'
    | 'hero-image-as-video-poster'
    | 'native-chartbeat'
    | 'black-friday'
    | 'top-50-schools'
    | '50-off-afl-breach-screen'
    | 'use-internal-content-api'
    | '30-off-breach-discount-biked130'
    | '50-off-breach-discount-govan50'
    | '50-off-breach-discount-coviddig'
    | 'breach-190-year'
    | 'adobe-audience-manager'
    | 'newsletter-subscriptions'
    | 'nielsen-subbrand'
    | 'app-upgrade-screen'
    | 'the-west-logo'
    | 'route-west-tonight'
    | '50-off-breach-discount'
    | 'south-west-curations'
    | 'sophi'
    | 'user-accounts'
    | '7news-taboola-midarticle'
    | 'cng-to-perth-now-rebrand'
    | 'route-up-late'
    | 'jab-tracker'
    | 'puzzles'
    | 'digital-edition-redirects'
    | 'the-west-grand-final'
    | 'the-west-grand-final-collection'
    | 'perthnow-streamer-screamer-play-of-the-day'
    | 'live-ramp-ats'
    | '7ent-article-related'
    | '7ent-show-page-7plus-button'
    | '7news-contextual-link'
    | 'the-west-cnbc'
    | 'subscribe-with-google'
    | '7ent-article-7plus-button'
    | '7ent-article-layout'
    | '7ent-show-layout'
    | 'cricket-widgets'
    | 'queen-elizabeth-tributes-route'
    | 'swg-breach-default'
    | 'swg-breach-albany-advertiser'
    | 'swg-breach-great-southern-herald'
    | 'swg-breach-augusta-margaret-river-times'
    | 'swg-breach-busselton-dunsborough-times'
    | 'swg-breach-broome-advertiser'
    | 'swg-breach-the-kimberley-echo'
    | 'swg-breach-geraldton-guardian'
    | 'swg-breach-midwest-times'
    | 'swg-breach-bunbury-herald'
    | 'swg-breach-harvey-waroona-reporter'
    | 'swg-breach-manjimup-bridgetown-times'
    | 'swg-breach-south-western-times'
    | 'swg-breach-kalgoorlie-miner'
    | 'swg-breach-narrogin-observer'
    | 'swg-breach-north-west-telegraph'
    | 'swg-breach-pilbara-news'
    | 'swg-breach-sound-telegraph'
    | 'swg-breach-countryman'
    | 'climate-change-home'
    | 'the-west-bar-regional'
    | 'taboola-bb-vip-show-page'
    | 'swg-entitlements-check'
    | 'perth-now-pride-logo'
    | '7-news-winters-hamburger-menu'
    | 'custom-sample-middleware'
    | 'feature-toggle-override'
    | 'subscriber-dropdown'
    | '7-lifestyle-full-page-layout'
    | 'subscriber-feature-tooltip'
    | '7-news-lifestyle-article-related-card'
    | '7-news-lifestyle-four-column-taboola-feed'
    | '7-news-lifestyle-article-full-page-display'
    | '7-news-sas-australia-article-full-page-display'
    | '7-news-sas-australia-article-7-plus-button'
    | '7-news-womens-afl-contextual-link'
    | 'entertainment-trending'
    | '7-news-lifestyle-contextual-link'
    | '7-news-sas-australia-full-page-layout'
    | '7-news-sas-australia-header'
    | '7-news-lifestyle-sub-topic-page-display'
    | '7-ent-sas-australia-show-page-watch-live-button'
    | '7-news-lifestyle-btyb-display'
    | 'hide-mobile-breaking-news-banner'
    | '7-news-sas-australia-article-related-card'
    | 'amp-read-more'
    | '7-news-dwts-full-show-page-display'
    | '7-news-lifestyle-right-hand-side-the-latest'
    | 'swg-account-linking'
    | '7-news-dwts-contextual-link'
    | '7news-dwts-full-article-page-display'
    | '7-entertainment-full-page-display'
    | '7-news-sas-australia-article-the-latest-right-hand-rail'
    | '7-entertainment-masthead'
    | '7-news-entertainment-sub-topic-page-display'
    | '7-politics-full-page-display'
    | '7-news-politics-full-page-article-display'
    | 'force-ads-hidden-until-loaded-false'
    | '7-news-sport-article-full-page-display'
    | '7-entertainment-article-full-page-display'
    | '7-news-sport-sub-topic-page-display'
    | '7-news-politics-sub-topic-page-display'
    | '7-entertainment-sunrise-full-article-display'
    | '7-entertainment-the-morning-show-full-article-display'
    | '7-news-sport-full-page-display'
    | '7-news-sunrise-full-page-display'
    | '7-news-finance-business-full-article-display'
    | '7-news-tech-full-page-display'
    | '7-news-tech-full-article-page-display'
    | '7-news-article-full-page-display'
    | '7-news-world-full-article-page-display'
    | '7-news-the-morning-show-full-page-display'
    | '7-news-sub-topic-page-display'
    | '7-news-tech-sub-topic-page-display'
    | '7-news-weather-topic-page'
    | '7-news-finance-topic-page'
    | '7-news-world-topic-page-display'
    | '7-news-home-page-full-page-display'
    | '7-news-weather-sub-topic-page-display'
    | '7-news-business-sub-topic-page'
    | '7-news-weather-full-article-page-display'
    | '7-news-the-voice-show-page'
    | '7-news-home-and-away-show-page'
    | 'pollie-rater-drivers'
    | '7-news-taboola-read-more-amp-articles'
    | 'live-coverage-driver'
    | '7-news-spotlight-full-article-display'
    | '7-news-spotlight-show-page'
    | '7-news-taboola-newsroom'
    | 'ipsos-tracking'
    | 'ipsos-tracking-amp'
    | 'geoblock-nsw-foul-play'
    | 'foul-play-editorial-feature'
    | '7-news-taboola-web-push'
    | 'subs-campaign-eofy-weekend-digital'
    | 'subs-campaign-business-pack-2022'
    | 'subs-campaign-sport-pack-2022'
    | 'subs-campaign-bali-bombing-2022'
    | 'PerthNow-rightsiderail-desktop-digital-edition-driver'
    | 'PerthNow-in-article-digital-edition-driver'
    | '7-news-google-web-stories-home-page'
    | '7-news-navigation-video-hub'
    | 'the-west-increased-article-font'
    | 'commonwealth-games-4card-curation'
    | 'commonwealth-games-play-of-the-day'
    | 'exclude-video-series-from-playlists'
    | 'commonwealth-games-sports-page-curation'
    | 'timespool-navigation'
    | 'do-not-refresh-while-inactive'
    | '7-news-individual-video-watch-page'
    | '7-news-heartbreak-full-article-page-display'
    | '7-news-redirect-logic'
    | 'web-stories'
    | '7-news-wfd-full-article-page-display'
    | 'the-west-grand-final-collection-home-4'
    | 'the-west-grand-final-freo-collection-theme'
    | 'the-west-grand-final-collection-home-8'
    | '7-news-afl-hub-strap-sport-page'
    | '7-news-afl-hub-strap-article-page'
    | '7-news-afl-hub-toggle-1'
    | '7-news-afl-hub-toggle-2'
    | '7-news-afl-hub-toggle-3'
    | 'flagmantle-route'
    | '7-news-video-hub-topic-page'
    | 'queens-tribute-in-article-banners'
    | 'perthnow-play-of-the-day'
    | 'best-australian-yarn-curation-segment'
    | 'best-australian-yarn-route'
    | '7-news-video-hub-playlist-fix'
    | 'bali-bombings-feature-route'
    | '7-news-agt-full-article-page-display'
    | 'subscriber-exclusive-subscriber-service-curation'
    | '7-news-cricket-fixture-scorecard'
    | 'exclusive_content'
    | 'gtm4'
    | '7-news-world-cup-fixture-scoreboard'
    | 'BAY-top-14'
    | '7-news-world-cup-hub-strap'
    | '7-news-world-cup-toggle-3'
    | '7-news-world-cup-hub-toggle-2'
    | '7-news-world-cup-hub-toggle-1'
    | 'extra-inline-article-ads'
    | 'tp-subscription-subscribe-button-design'
    | 'tp-subscription-new-breach-package-design'
    | 'tp-subscription-new-breach-package-background'
    | 'tp-subscription-breach-show-part-article'
    | 'tp-subscription-abandoned-cart'
    | 'tp-subscription-hero-variation'
    | 'teachers-offering'
    | 'university-offering'
    | 'ePaper'
    | 'genwest'
    | 'genwest-taboola'
    | 'genwest-ad-slots'
    | '7-news-careerone-widget-integration'
    | '7-news-careerone-navigation-and-contextual-links'
    | 'trading-up'
    | 'trading-up-stake-images'
    | '7-news-linkby-pubfeed'
    | 'a-b-testing-features'
    | '7news-mobile-video-autoplay'
    | '7-news-sponsored-disclaimer'
    | '7-news-afl-fixture-scoreboard'
    | 'round-style-perth-now'
    | 'smartocto'
    | 'perth-now-match-centre'
    | '7-news-match-centre-odds-toggle'
    | 'perth-now-afl-fixture-scoreboard'
    | '7-news-afl-fixture-scoreboard-home-page'
    | 'trading-up-homepage'
    | 'video-hub'
    | 'the-west-match-centre'
    | 'the-west-afl-fixture-scoreboard'
    | '7-news-afl-fixture-scoreboard-home-page-lead'
    | 'afl-match-centre-driver'
    | 'datadog-client'
    | '7-news-fifa-wwc-masthead'
    | '7-news-fifa-wwc-strap'
    | '7-news-fifa-wwc-page'
    | '7-news-fifa-wwc-navigation'
    | '7-news-fifa-wwc-contextual-link'
    | '7-news-fifa-wwc-hub-location-1'
    | '7-news-fifa-wwc-location-2'
    | '7-news-fifa-wwc-location-3'
    | '7-news-video-hub-sunrise-page'
    | 'kings-coronation'
    | 'kings-coronation-position'
    | 'kings-coronation-topic-page'
    | 'perthnow-taboola-web-push'
    | 'the-west-wafl-landing'
    | 'best-australian-yarn-gen-west'
    | 'mad-monday-route'
    | 'tw-1000-promo'
    | 'breachwall-banner'
    | '7-news-main-navigation-update'
    | '190-years-of-the-west'
    | '7-news-adfixus-script-tag'
    | '7-news-fifa-wwc-fixture-scoreboard'
    | '190-years-of-the-west-masthead'
    | '7-news-video-hub-topic-pages'
    | '7news-tv-guide-navigation'
    | '7news-best-picks-home-page'
    | '7news-fifa-wwc-match-centre-btyb'

export interface ABTestingFeature {
    on: { percentage: number; value: unknown }
    defaultValue: unknown
}
export type ABTestingFeatures = Omit<
    { [K in Features]?: ABTestingFeature },
    'a-b-testing-features'
>

export const testFeatureState: TogglesReduxState = {
    'perthnow-taboola-web-push': true,
    ePaper: true,
    'video-hub': true,
    'BAY-top-14': true,
    'world-collection': true,
    'brightcove-player': true,
    'ix-header-tag-wrapper': true,
    'email-author': true,
    'google-tag-manager': true,
    'gpt-ads': true,
    'nielsen-events': true,
    'refresh-on-inactive': false,
    'can-autoplay-video': true,
    'can-autoplay-next': false,
    'can-autoplay-muted-video': false,
    'big-mobile-amp': false,
    'related-content': false,
    snowplow: true,
    'prebid-video': true,
    search: false,
    'debug-ads': false,
    'newsletter-subscription-banner': false,
    'sticky-mrec': false,
    'standalone-amp-swm-player': false,
    'moat-adx-ad-tracking': true,
    'nielsen-video-events': true,
    'inline-card-video': true,
    canary: false,
    // 'use-oovvuu-recommendation': false,
    cricketball: false,
    'digital-subscriptions': false,
    'bonzai-truskin': false,
    outstream: false,
    'ad-tech-dfp-testing': true,
    'nielsen-video-events-inline-videos': false,
    grapeshot: false,
    'mmo-bypass': false,
    'paywall-bypass-header': true,
    ripple: false,
    regionals: true,
    'immersive-story-article-template': false,
    'telethon-countdown': false,
    'running-parallax': false,
    'logo-takeover': false,
    'afl-draft': false,
    'simple-digital-subscription-form': false,
    'moat-yield-intelligence': false,
    'exclude-regional-topics-from-lists': false,
    'video-playlist': false,
    'cookie-consent': false,
    'community-news': true,
    'cng-to-perth-now-rebrand': true,
    'the-west-live': false,
    'playlists-on-inline-videos': false,
    'native-lazy-loading': false,
    'force-west-live-activation': false,
    'video-series': true,
    'sport-breach-screen-variant': true,
    taboola: true,
    'taboola-regionals': true,
    'companion-ads': false,
    'story-classification': true,
    'the-west-rewards': true,
    'registration-wall': true,
    comments: false,
    'hero-image-as-video-poster': true,
    'native-chartbeat': true,
    'black-friday': false,
    'top-50-schools': true,
    'use-internal-content-api': true,
    '50-off-afl-breach-screen': true,
    '30-off-breach-discount-biked130': true,
    '50-off-breach-discount-govan50': false,
    '50-off-breach-discount-coviddig': false,
    'breach-190-year': true,
    'adobe-audience-manager': false,
    'newsletter-subscriptions': true,
    'nielsen-subbrand': true,
    'app-upgrade-screen': true,
    'the-west-logo': true,
    'route-west-tonight': true,
    '50-off-breach-discount': false,
    'south-west-curations': false,
    sophi: false,
    'user-accounts': false,
    '7news-taboola-midarticle': true,
    'route-up-late': true,
    'jab-tracker': true,
    'puzzles-target': false,
    puzzles: true,
    'digital-edition-redirects': true,
    'the-west-grand-final': true,
    'the-west-grand-final-collection': true,
    'perthnow-streamer-screamer-play-of-the-day': true,
    'live-ramp-ats': true,
    '7ent-article-related': true,
    '7ent-show-page-7plus-button': true,
    '7news-contextual-link': true,
    'the-west-cnbc': true,
    'subscribe-with-google': false,
    '7ent-article-7plus-button': true,
    '7ent-article-layout': true,
    '7ent-show-layout': true,
    'cricket-widgets': true,
    'swg-breach-default': false,
    'swg-breach-albany-advertiser': false,
    'swg-breach-great-southern-herald': false,
    'swg-breach-augusta-margaret-river-times': false,
    'swg-breach-busselton-dunsborough-times': false,
    'swg-breach-broome-advertiser': false,
    'swg-breach-the-kimberley-echo': false,
    'swg-breach-geraldton-guardian': false,
    'swg-breach-midwest-times': false,
    'swg-breach-bunbury-herald': false,
    'swg-breach-harvey-waroona-reporter': false,
    'swg-breach-manjimup-bridgetown-times': false,
    'swg-breach-south-western-times': false,
    'swg-breach-kalgoorlie-miner': false,
    'swg-breach-narrogin-observer': false,
    'swg-breach-north-west-telegraph': false,
    'swg-breach-pilbara-news': false,
    'swg-breach-sound-telegraph': false,
    'swg-breach-countryman': false,
    'climate-change-home': false,
    'the-west-bar-regional': true,
    'taboola-bb-vip-show-page': true,
    'swg-entitlements-check': false,
    'perth-now-pride-logo': false,
    '7-news-winters-hamburger-menu': false,
    'custom-sample-middleware': false,
    'feature-toggle-override': true,
    'subscriber-dropdown': true,
    '7-lifestyle-full-page-layout': true,
    'subscriber-feature-tooltip': true,
    '7-news-lifestyle-article-related-card': true,
    '7-news-lifestyle-four-column-taboola-feed': true,
    '7-news-lifestyle-article-full-page-display': true,
    '7-news-sas-australia-article-full-page-display': true,
    '7-news-sas-australia-article-7-plus-button': true,
    '7-news-womens-afl-contextual-link': true,
    '7-news-lifestyle-contextual-link': true,
    'entertainment-trending': false,
    '7-news-sas-australia-full-page-layout': true,
    '7-news-sas-australia-header': true,
    '7-news-lifestyle-sub-topic-page-display': true,
    '7-ent-sas-australia-show-page-watch-live-button': true,
    '7-news-lifestyle-btyb-display': true,
    'hide-mobile-breaking-news-banner': true,
    '7-news-sas-australia-article-related-card': true,
    'amp-read-more': true,
    '7-news-dwts-full-show-page-display': true,
    '7-news-lifestyle-right-hand-side-the-latest': true,
    'swg-account-linking': false,
    '7-news-dwts-contextual-link': true,
    '7news-dwts-full-article-page-display': true,
    '7-entertainment-full-page-display': true,
    '7-news-sas-australia-article-the-latest-right-hand-rail': true,
    '7-entertainment-masthead': true,
    '7-news-entertainment-sub-topic-page-display': true,
    '7-politics-full-page-display': true,
    '7-news-politics-full-page-article-display': true,
    'force-ads-hidden-until-loaded-false': true,
    '7-news-sport-article-full-page-display': true,
    '7-entertainment-article-full-page-display': true,
    '7-news-sport-sub-topic-page-display': true,
    '7-news-politics-sub-topic-page-display': true,
    '7-entertainment-sunrise-full-article-display': true,
    '7-entertainment-the-morning-show-full-article-display': true,
    '7-news-sport-full-page-display': true,
    '7-news-sunrise-full-page-display': true,
    '7-news-finance-business-full-article-display': true,
    '7-news-tech-full-page-display': true,
    '7-news-tech-full-article-page-display': true,
    '7-news-article-full-page-display': true,
    '7-news-world-full-article-page-display': true,
    '7-news-the-morning-show-full-page-display': true,
    '7-news-sub-topic-page-display': true,
    '7-news-tech-sub-topic-page-display': true,
    '7-news-weather-topic-page': true,
    '7-news-finance-topic-page': true,
    '7-news-world-topic-page-display': true,
    '7-news-home-page-full-page-display': true,
    '7-news-weather-sub-topic-page-display': true,
    '7-news-business-sub-topic-page': true,
    '7-news-weather-full-article-page-display': true,
    '7-news-the-voice-show-page': true,
    '7-news-home-and-away-show-page': true,
    'pollie-rater-drivers': true,
    '7-news-taboola-read-more-amp-articles': true,
    'live-coverage-driver': true,
    '7-news-spotlight-full-article-display': true,
    '7-news-spotlight-show-page': true,
    '7-news-taboola-newsroom': true,
    'ipsos-tracking': true,
    'ipsos-tracking-amp': true,
    'geoblock-nsw-foul-play': true,
    'foul-play-editorial-feature': true,
    '7-news-taboola-web-push': true,
    'subs-campaign-eofy-weekend-digital': false,
    'subs-campaign-sport-pack-2022': false,
    'subs-campaign-business-pack-2022': false,
    'subs-campaign-bali-bombing-2022': false,
    'PerthNow-rightsiderail-desktop-digital-edition-driver': false,
    'PerthNow-in-article-digital-edition-driver': false,
    '7-news-google-web-stories-home-page': true,
    '7-news-navigation-video-hub': true,
    'the-west-increased-article-font': false,
    'commonwealth-games-4card-curation': false,
    'commonwealth-games-play-of-the-day': true,
    'exclude-video-series-from-playlists': false,
    'commonwealth-games-sports-page-curation': false,
    'timespool-navigation': true,
    'do-not-refresh-while-inactive': false,
    '7-news-individual-video-watch-page': true,
    '7-news-heartbreak-full-article-page-display': true,
    '7-news-redirect-logic': true,
    'web-stories': true,
    '7-news-wfd-full-article-page-display': true,
    'the-west-grand-final-collection-home-4': false,
    'the-west-grand-final-freo-collection-theme': false,
    'the-west-grand-final-collection-home-8': false,
    '7-news-afl-hub-strap-sport-page': true,
    '7-news-afl-hub-strap-article-page': true,
    '7-news-afl-hub-toggle-1': true,
    '7-news-afl-hub-toggle-2': true,
    '7-news-afl-hub-toggle-3': true,
    'flagmantle-route': true,
    '7-news-video-hub-topic-page': true,
    'queens-tribute-in-article-banners': true,
    'perthnow-play-of-the-day': true,
    'best-australian-yarn-curation-segment': true,
    'best-australian-yarn-route': true,
    '7-news-video-hub-playlist-fix': false,
    'bali-bombings-feature-route': true,
    '7-news-agt-full-article-page-display': true,
    'subscriber-exclusive-subscriber-service-curation': true,
    '7-news-cricket-fixture-scorecard': true,
    exclusive_content: true,
    gtm4: false,
    '7-news-world-cup-fixture-scoreboard': true,
    '7-news-world-cup-hub-strap': true,
    '7-news-world-cup-toggle-3': true,
    '7-news-world-cup-hub-toggle-2': true,
    '7-news-world-cup-hub-toggle-1': true,
    'extra-inline-article-ads': true,
    'tp-subscription-subscribe-button-design': false,
    'tp-subscription-new-breach-package-design': false,
    'tp-subscription-new-breach-package-background': false,
    'tp-subscription-breach-show-part-article': false,
    'tp-subscription-abandoned-cart': false,
    'tp-subscription-hero-variation': 'a',
    'teachers-offering': true,
    'university-offering': true,
    genwest: true,
    'genwest-taboola': false,
    'genwest-ad-slots': false,
    '7-news-careerone-widget-integration': true,
    '7-news-careerone-navigation-and-contextual-links': true,
    'trading-up': true,
    'trading-up-stake-images': true,
    '7-news-linkby-pubfeed': true,
    'afl-match-centre-driver': false,
    'a-b-testing-features': {
        'tp-subscription-subscribe-button-design': {
            on: { percentage: 50, value: false },
            defaultValue: false,
        },
        'tp-subscription-new-breach-package-design': {
            on: { percentage: 50, value: false },
            defaultValue: false,
        },
        'tp-subscription-new-breach-package-background': {
            on: { percentage: 50, value: false },
            defaultValue: false,
        },
        'tp-subscription-breach-show-part-article': {
            on: { percentage: 50, value: false },
            defaultValue: false,
        },
        'tp-subscription-abandoned-cart': {
            on: { percentage: 50, value: false },
            defaultValue: false,
        },
        'tp-subscription-hero-variation': {
            on: { percentage: 50, value: 'b' },
            defaultValue: 'a',
        },
    },
    '7news-mobile-video-autoplay': true,
    '7-news-sponsored-disclaimer': true,
    '7-news-afl-fixture-scoreboard': true,
    'round-style-perth-now': true,
    smartocto: false,
    'perth-now-match-centre': true,
    '7-news-match-centre-odds-toggle': true,
    '7-news-afl-fixture-scoreboard-home-page': true,
    'trading-up-homepage': true,
    'the-west-match-centre': true,
    'the-west-afl-fixture-scoreboard': true,
    '7-news-afl-fixture-scoreboard-home-page-lead': true,
    'datadog-client': false,
    '7-news-fifa-wwc-masthead': true,
    '7-news-fifa-wwc-strap': true,
    '7-news-fifa-wwc-page': true,
    '7-news-fifa-wwc-navigation': true,
    '7-news-fifa-wwc-contextual-link': true,
    '7-news-fifa-wwc-hub-location-1': true,
    '7-news-fifa-wwc-location-2': true,
    '7-news-fifa-wwc-location-3': true,
    '7-news-video-hub-sunrise-page': true,
    'kings-coronation': true,
    'kings-coronation-position': true,
    'kings-coronation-topic-page': true,
    'best-australian-yarn-gen-west': true,
    'mad-monday-route': true,
    'the-west-wafl-landing': true,
    'tw-1000-promo': false,
    'breachwall-banner': true,
    '7-news-main-navigation-update': true,
    '190-years-of-the-west': true,
    '7-news-adfixus-script-tag': true,
    '7-news-fifa-wwc-fixture-scoreboard': true,
    '190-years-of-the-west-masthead': false,
    '7-news-video-hub-topic-pages': true,
    '7news-tv-guide-navigation': true,
    '7news-best-picks-home-page': true,
    '7news-fifa-wwc-match-centre-btyb': true,
}
